import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { RotateCcwIcon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
import { proofPoints } from '../../data/teaser';
type ProofScreenProps = {
  onReplay: () => void;
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function ProofScreen({
  onReplay
}: ProofScreenProps) {
  const [clicked, setClicked] = useState(false);
  return <div className="flex h-full flex-col" data-id="element-822" data-mp="29byldy37kjut">
      <h2 className="text-[32px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-823" data-mp="2e9qfmyrbsi26">Individualization with evidence behind it.</h2>

      <ul className="mt-7 border-b border-ink/10" data-id="element-824" data-mp="2iaaa1ukil7km">
        {proofPoints.map(p => <li key={p.title} className="border-t border-ink/10 py-4" data-id="element-825" data-mp="2naol7lhewxmv">
            <p className="text-[16px] font-semibold leading-snug tracking-[-0.01em] text-ink" data-id="element-826" data-mp="3tqigi732h31k">{p.title}</p>
            <p className="mt-1.5 inline-block rounded border border-dashed border-rx/40 bg-rx/[0.04] px-2 py-0.5 font-mono text-[10px] tracking-[0.06em] text-rx" data-id="element-827" data-mp="2jxiu4iiawvk">
              {p.placeholder}
            </p>
          </li>)}
      </ul>

      <p className="mt-6 text-[17px] font-medium leading-snug tracking-[-0.01em] text-ink" data-id="element-828" data-mp="2u3lbuckbgl0e">
        Different patients may need a more individualized starting approach.
      </p>

      <div className="mt-auto pt-6" data-id="element-829" data-mp="2k4vwaqfw7cnb">
        <PrimaryButton onClick={() => setClicked(true)} data-id="element-830" data-mp="2k3ujagfbgg2y">SEE THE EVIDENCE</PrimaryButton>
        <div className="mt-2 flex h-5 items-center justify-center" data-id="element-831" data-mp="2g424hlzbxdp5">
          <AnimatePresence initial={false} data-id="element-832" data-mp="2bbipqlowocir">
            {clicked && <motion.p key="note" initial={{
            opacity: 0,
            y: 4
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: EASE
          }} className="text-[12px] text-graphite" data-id="element-833" data-mp="26cfxy2xxs2sq">
                Opens the approved evidence page in the live Snak.
              </motion.p>}
          </AnimatePresence>
        </div>
        <PrimaryButton variant="outline" onClick={onReplay} className="mt-2" data-id="element-834" data-mp="1hq9nb45nyjiz">
          <span className="inline-flex items-center justify-center gap-2" data-id="element-835" data-mp="1mryzwo8jb596">
            <RotateCcwIcon size={15} strokeWidth={2} aria-hidden="true" data-id="element-836" data-mp="18ro2t3gmsufk" />
            REPLAY
          </span>
        </PrimaryButton>
      </div>
    </div>;
}